import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Section from "../../components/about/Section";
import ResponsiveImage from "../../components/about/ResponsiveImage";
const TaskFiltering = () => {
  return (
    <Page className="about-page task-filtering-page" pageKey="task-filtering">
      <AboutTemplate>
        <Typography variant="h1">Task filtering</Typography>
        <Section>
          <Typography variant="p1">
            Task filtering is a way to see a more specific set of tasks, based
            on their{" "}
            <Link
              component={RouterLink}
              to="/about/features/tasks/labels"
              variant="p1Link"
            >
              labels
            </Link>
            .
          </Typography>
          <Typography variant="body1">
            You can open the filter dialog by clicking the "Filter" chip at the
            top of your task stack, next to the Sort and Search controls.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="filter-chip"
            size="large"
          />
        </Section>
        <Section title="The filter dialog">
          <Typography variant="body1">
            Clicking the Filter chip will open the Filter Tasks dialog. This
            shows all of your labels and lets you choose to include or exclude
            each one.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="filter-dialog"
            size="medium"
          />
          <Typography variant="body1">
            At the top of the dialog, a summary bar shows how many filters are
            currently active. A legend below it explains the meaning of the
            include and exclude icons.
          </Typography>
        </Section>
        <Section title="Including labels">
          <Typography variant="body1">
            To include a label, click the green include button (tick icon) next
            to the label. When a label is included, only tasks with that label
            will be displayed in your stack.
          </Typography>
          <Typography variant="body1">
            You can include multiple labels at once. Tasks that have any of the
            included labels will be shown.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="include-label"
            size="medium"
          />
        </Section>
        <Section title="Excluding labels">
          <Typography variant="body1">
            To exclude a label, click the red exclude button (cross icon) next
            to the label. When a label is excluded, tasks with that label will
            be hidden from your stack.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="exclude-label"
            size="medium"
          />
        </Section>
        <Section title="Combining includes and excludes">
          <Typography variant="body1">
            You can combine includes and excludes to get a very specific view of
            your tasks. Only tasks that match the included labels and do not
            match the excluded labels will be displayed.
          </Typography>
          <Typography variant="body1">
            A label can only be included or excluded - not both at the same
            time. Setting one will automatically clear the other.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="combined-filters"
            size="medium"
          />
        </Section>
        <Section title="Active filter indicator">
          <Typography variant="body1">
            When filters are active, the Filter chip in the header will update
            to show the number of active filters, making it easy to tell at a
            glance when your stack is being filtered.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="active-filter-indicator"
            size="medium"
          />
        </Section>
        <Section title="Clearing filters">
          <Typography variant="body1">
            You can clear all active filters at once by clicking the "Clear All"
            button at the top of the filter dialog. This will remove all
            includes and excludes, showing your full task stack again.
          </Typography>
          <ResponsiveImage
            pageKey="taskFiltering"
            imageName="clear-all"
            size="medium"
          />
        </Section>
      </AboutTemplate>
    </Page>
  );
};
export default TaskFiltering;
